// removed by extract-text-webpack-plugin
module.exports = {"controlButton":"ComparePlayer__controlButton--T92Cl"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/ComparePlayer/ComparePlayer.css
// module id = 4h3j
// module chunks = 47